import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { FileUploadControl } from "../../../Controls/FileUpload";
import { app } from "../../../Frame/App";
import { WidgetDashboard } from "../Widgets/WidgetDashboard";

const allowedExtensions = "png,jpeg,jpg,gif";

export type PopupDashboardComponentProps = {
    widget: WidgetDashboard;
}

export class PopupDashboardComponent extends JSXComponent {
    props: PopupDashboardComponentProps;
    title: LanguageStringComponent;
    fileUploadImageControl: FileUploadControl;
    fileElement: HTMLElement;

    constructor(props: PopupDashboardComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.recreate();
        return true;
    }

    
    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetImage} cssClass="popup-image-component">
            {this.renderTitle()}
            <TextComponent model={this.props.widget.props} field="reportId" name="Report Id" />
        </DynPopup>

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        }); 
        return this.title.render();
    }

    //renderUploadElement(): HTMLElement {
    //    this.fileElement = <div class="documents-frame mb-2 w-50" id="fileUploadWidgetImage"></div>
    //    this.fileUploadImageControl = new FileUploadControl(this.fileElement, "~/api/widget/uploadWidgetImage", true, allowedExtensions, `~/api/widget/deleteWidgetImage/${this.props.widget.props.image}`);
       
    //    this.fileUploadImageControl.notAllowedExtensionEvent.subscribe((sender, arg) => {
    //        this.onFileUploadWrongExtension(sender, arg);
    //    });
    //    this.fileUploadImageControl.fileUploadedEvent.subscribe((sender, arg) => {
    //        this.onFilesChanged(sender, arg);
    //    });

    //    this.fileUploadImageControl.deleteIsController = false;
    //    this.fileUploadImageControl.fileDeletedEvent.subscribe((sender, arg) => {
    //        $('#PopupDashboard').children().remove();
    //        $('#PopupDashboard').removeClass("img-thumbnail");
    //        this.props.widget.props.image = "";
    //    });

    //    this.fileUploadImageControl.init(this.props.widget.props.image,1);
    //    return this.fileElement;
    //}

    //renderImage() {
    //    let imgElement: HTMLElement = <div id="PopupDashboard" className="widget-image" style={{ width: "50%" }}>
    //        {this.props.widget.props.image ? this.props.widget.showImage() : []}
    //    </div>

    //    if (this.props.widget.props.image)
    //        imgElement.classList.add("img-thumbnail");

    //    return imgElement;
    //}
 
    //onFilesChanged(sender: FileUploadControl, data: any) {
    //    if (data.data.success) {
    //        this.props.widget.props.image = data.data.fileName;
    //        $('#PopupDashboard').children().remove();
    //        $('#PopupDashboard').append(this.props.widget.showImage());
    //    }
    //    else if (data.error == "wrongExtension") {
    //        this.showWrongExtensionMessage(sender, data.extension);
    //    }
    //}

    //onFileUploadWrongExtension(fileUploadControl: FileUploadControl, extension: string) {
    //    this.showWrongExtensionMessage(fileUploadControl, extension);
    //}

    //showWrongExtensionMessage(fileUploadControl: FileUploadControl, extension: string) {
    //    new FixedDialog(fileUploadControl.element)
    //        .showOk((Resources.Common.fileUploadInvalidExtension).format(extension), 100, -30);
    //}

    render(): HTMLElement {
        return this.element;
    }
}
